import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'

export const PERMANENT_PASS_TYPES: RequestTypeAlias[] = [
  RequestTypeAlias.PermanentPassFamily,
  RequestTypeAlias.PermanentPassStaff,
  RequestTypeAlias.PermanentPassRenter,
  RequestTypeAlias.PermanentPassAuto
] as const

export const AVAILABLE_PASS_TYPES: RequestTypeAlias[] = [
  RequestTypeAlias.PermanentPass,
  RequestTypeAlias.GuestPass,
  RequestTypeAlias.CourierPass,
  RequestTypeAlias.GuestPassAuto,
  RequestTypeAlias.PropertiesPass,
  RequestTypeAlias.RentPassAuto
] as const
